(function () {
  var DURATION_MS = 350;
  var EASING = 'ease';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function panelContentHeight(panel) {
    var inner = panel.querySelector('.iw-faq__answer') || panel.firstElementChild;
    return inner ? inner.scrollHeight : panel.scrollHeight;
  }

  function currentPanelHeight(panel) {
    var h = panel.getBoundingClientRect().height;
    return Math.round(h);
  }

  function clearPanelMotion(panel) {
    panel.style.transition = '';
    panel.style.overflow = '';
  }

  function animatePanel(panel, fromPx, toPx, duration, done) {
    panel.style.overflow = 'hidden';
    panel.style.height = fromPx + 'px';
    panel.offsetHeight;
    panel.style.transition = 'height ' + duration + 'ms ' + EASING;
    panel.style.height = toPx + 'px';

    function onTransitionEnd(event) {
      if (event.target !== panel || event.propertyName !== 'height') return;

      panel.removeEventListener('transitionend', onTransitionEnd);
      clearPanelMotion(panel);
      done();
    }

    panel.addEventListener('transitionend', onTransitionEnd);
  }

  function closeItem(details, immediate) {
    var panel = details.querySelector('.iw-faq__panel');

    if (!panel || !details.open) return;

    if (immediate || prefersReducedMotion()) {
      details.open = false;
      panel.style.height = '0px';
      clearPanelMotion(panel);
      return;
    }

    var startH = currentPanelHeight(panel);

    animatePanel(panel, startH, 0, DURATION_MS, function () {
      details.open = false;
      panel.style.height = '0px';
    });
  }

  function closeOtherItems(currentDetails) {
    var list = currentDetails.closest('.iw-faq__list');

    if (!list) return;

    list.querySelectorAll('.iw-faq__item[open]').forEach(function (item) {
      if (item !== currentDetails) {
        closeItem(item, false);
      }
    });
  }

  function bindItem(details) {
    var summary = details.querySelector('.iw-faq__summary');
    var panel = details.querySelector('.iw-faq__panel');

    if (!summary || !panel || details.dataset.iwFaqBound) return;

    details.dataset.iwFaqBound = 'true';

    var animating = false;

    if (details.open) {
      panel.style.height = 'auto';
    } else {
      panel.style.height = '0px';
    }

    summary.addEventListener('click', function (event) {
      event.preventDefault();

      if (animating) return;

      var reduced = prefersReducedMotion();

      // CLOSE CURRENT FAQ
      if (details.open) {
        if (reduced) {
          details.open = false;
          panel.style.height = '0px';
          return;
        }

        animating = true;

        var startH = currentPanelHeight(panel);

        animatePanel(panel, startH, 0, DURATION_MS, function () {
          details.open = false;
          panel.style.height = '0px';
          animating = false;
        });

        return;
      }

      // OPEN THIS FAQ
      closeOtherItems(details);

      if (reduced) {
        details.open = true;
        panel.style.height = 'auto';
        return;
      }

      animating = true;

      details.open = true;

      var endH = panelContentHeight(panel);

      panel.style.height = '0px';
      panel.offsetHeight;

      animatePanel(panel, 0, endH, DURATION_MS, function () {
        panel.style.height = 'auto';
        animating = false;
      });
    });
  }

  function initSection(section) {
    var list = section.querySelector('.iw-faq__list');

    if (!list || list.dataset.iwFaqInit === 'true') return;

    list.dataset.iwFaqInit = 'true';

    list.querySelectorAll('.iw-faq__item').forEach(bindItem);
  }

  function initAll() {
    document.querySelectorAll('.section-iw-faq').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;

    if (
      section.classList &&
      section.classList.contains('section-iw-faq')
    ) {
      initSection(section);
    }
  });
})();